import { Box, Typography } from '@mui/material';
import UnassignedField from '@/components/global/fields/UnassignedField.jsx';
import PropTypes from 'prop-types';

export const ContractorUserMasterField = ({ record }) => {
    return (
        <>
            {record.userMaster ? (
                <Box display='flex' flexDirection='column' gap='4px'>
                    <Typography variant='body1'>
                        {record.userMaster.firstName} {record.userMaster.lastName}
                    </Typography>
                    <Typography sx={{ fontSize: '11px !important' }}>{record.userMaster.email}</Typography>
                </Box>
            ) : (
                <UnassignedField />
            )}
        </>
    );
};

ContractorUserMasterField.propTypes = {
    record: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userMaster: PropTypes.shape({
            id: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
        }),
    }),
};
